
/**
 * Slick setup
 */
$(document).ready(function () {

    $('.gallery-headerslider').not('.star').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slider, i) {
            return '<div class="slide-dot">';
        },
        slide: '.slide',
        arrows: true,
        dots: false,
        autoplay:true,
        autoplaySpeed:8000,
        fade: true,
        cssEase: 'linear',
        prevArrow:"<div class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></div>",
        nextArrow:"<div class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></div>"
    });
    
    

    $('.image-full-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slider, i) {
            return '<div class="slide-dot">';
        },
        slide: '.teaser-box',
        arrows: false,
        dots: false,
        autoplay:true,
        autoplaySpeed:13000,
        fade: true,
        cssEase: 'linear'
    });



    // ----------------------------------------------
    // Slides (http://kenwheeler.github.io/slick/)
    // ----------------------------------------------
    $('.fullservice-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slider, i) {
            return '<div class="slide-dot">';
        },
        // nextArrow: '<div class="slide-control next"></div>',
        // prevArrow: '<div class="slide-control prev"></div>',
        slide: '.slide',
        arrows: false,
        swipe: false,
        dots: false,
        autoplay:false,
        autoplaySpeed:13000,
        fade: true,
        cssEase: 'linear'
    });


    $('.fullservice-pager li').click(function() {
      var index=$('.fullservice-pager li').index($(this));
      console.log(index);
      $('.fullservice-slider').slick('slickGoTo', index);
    })



    // ----------------------------------------------
    // Slides (http://kenwheeler.github.io/slick/)
    // ----------------------------------------------

    $('.contact-slider').on('init', function(event,slick){
      $('.contact-slider li').eq(0).addClass('progress');
    });


    $('.contact-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slider, i) {
            return '<div class="slide-dot">';
        },
        nextArrow: '<div class="slide-control next"></div>',
        prevArrow: '<div class="slide-control prev"></div>',
        slide: '.slide',
        arrows: false,
        dots: true,
        autoplay:true,
        pauseOnHover: false,
        autoplaySpeed:11000,
        fade: true,
        cssEase: 'linear'
    });



    $('.contact-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){

        if (nextSlide==0) {
            $('.contact-slider li').removeClass('progress');
            $('.contact-slider li').removeClass('fast');
        }

        // if (nextSlide==0) {
        //
        //     $('.contact-slider li').removeClass('progress');
        //     $('.contact-slider li').removeClass('fast');
        //
        // }
    });


    $('.contact-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      //if (nextSlide==0) {
        //$('.contact-slider li').removeClass('progress');
      //}





       for (e=0;e<=currentSlide;e++) {
           if (e==currentSlide) {
               $('.contact-slider li').eq(e).addClass('progress');
           }
           else
           {
               $('.contact-slider li').eq(e).addClass('progress').addClass('fast');
           }
       }




   });





    // ----------------------------------------------
    // Carousel (http://kenwheeler.github.io/slick/)
    // ----------------------------------------------
    $('.portletCarousel').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
            // {
            //     breakpoint: 300,
            //     settings: {
            //         slidesToShow: 1,
            //         slidesToScroll: 1,
            //         dots: false
            //     }
            // }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
        // arrows: true,
        nextArrow: '<div class="slide-control next"></div>',
        prevArrow: '<div class="slide-control prev"></div>',
        dots: false
        //variableWidth: true
    });

});
